/* CITIMI – cart drawer and fast "Add to cart".
   - Add to cart: the button shows loading dots at once; one request adds the item and brings back the
     freshly rendered cart (Shopify section rendering), and the drawer opens as soon as it arrives.
     (The theme's own flow waited ~1.5 s on purpose and then loaded every cart item one by one.)
   - The bag icon opens the drawer instead of the theme's small drop-down.
   - Inside: - / + and Remove, Clear cart, the gift note (saved while typing), Checkout.
   - Errors from Shopify (e.g. not enough stock) appear under the form like before.
   If anything is missing (no drawer on the page, the cart page itself), the theme's own behaviour stays. */
(function () {
  var SECTION = 'citimi-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var phone = window.matchMedia('(max-width: 798px)');
  var drawer = null;
  var lastFocus = null;
  var queue = Promise.resolve(); // cart changes run one after another
  var noteTimer = 0;

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function isOpen() { return !!drawer && drawer.classList.contains('is-open'); }
  function onCartPage() { return document.body.classList.contains('cart'); }

  /* ---------- requests ---------- */
  function post(url, body, isForm) {
    var headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
    if (!isForm) headers['Content-Type'] = 'application/json';
    return fetch(ROOT + url, { method: 'POST', credentials: 'same-origin', headers: headers, body: isForm ? body : JSON.stringify(body) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok || data.status) {
            var err = new Error(data.description || data.message || 'Cart error');
            err.data = data;
            throw err;
          }
          return data;
        });
      });
  }

  /* ---------- render the fresh cart HTML ---------- */
  function render(sections) {
    var html = sections && sections[SECTION];
    if (html) {
      apply(html);
      return Promise.resolve();
    }
    // older responses without the section: ask for it separately
    return fetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) { apply(json[SECTION]); });
  }

  function apply(html) {
    if (!html || !drawer) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-citimi-cart-content]');
    var content = $('[data-citimi-cart-content]', drawer);
    if (!fresh || !content) return;
    // keep a gift note that is still being typed
    var note = $('[data-citimi-cart-note]', content);
    var typed = note && note.value;
    var typing = note && document.activeElement === note;
    content.innerHTML = fresh.innerHTML;
    content.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
    var newNote = $('[data-citimi-cart-note]', content);
    if (newNote && typed != null && newNote.value !== typed) newNote.value = typed;
    if (newNote && typing) newNote.focus({ preventScroll: true });
    updateCounts(parseInt(content.getAttribute('data-count'), 10) || 0);
  }

  function updateCounts(n) {
    $$('.cart_count').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- open / close ---------- */
  function place() {
    // phones: the drawer starts right under the header (like pdpaola); computers: full height
    var top = 0;
    if (phone.matches) {
      var bar = $('#header .top-bar') || $('#header');
      if (bar) {
        var r = bar.getBoundingClientRect();
        if (r.bottom > 0 && r.height > 0) top = Math.round(r.bottom);
      }
    }
    drawer.style.setProperty('--citimi-cart-top', top + 'px');
  }

  function open() {
    if (!drawer || isOpen()) return;
    // the theme's phone menu closes first (the theme's own mini cart did the same)
    if (window.mobileMenuDrawer && typeof window.mobileMenuDrawer.close === 'function') {
      try { window.mobileMenuDrawer.close(); } catch (e) {}
    }
    lastFocus = document.activeElement;
    place();
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    var html = document.documentElement;
    html.style.setProperty('--citimi-scrollbar', Math.max(0, window.innerWidth - html.clientWidth) + 'px');
    html.classList.add('citimi-cart-open');
    // let the closed position paint first so the slide-in always runs
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    var panel = $('.citimi-cart__panel', drawer);
    if (panel) panel.focus({ preventScroll: true });
  }

  function close() {
    if (!drawer || !isOpen()) return;
    saveNote();
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.documentElement.classList.remove('citimi-cart-open');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- add to cart ---------- */
  function setLoading(btn, on) {
    if (on && !$('.citimi-dots', btn)) {
      var dots = document.createElement('i'); // not a <span>: the theme rewrites spans inside this button
      dots.className = 'citimi-dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = '<b></b><b></b><b></b>';
      btn.appendChild(dots);
    }
    btn.classList.toggle('is-citimi-loading', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function showError(form, btn, data) {
    var recipient = form.querySelector('[data-recipient-form]');
    if (data && data.errors && data.errors.email && recipient) {
      recipient.classList.add('recipient-form--has-errors');
      return;
    }
    var text = (data && (data.description || data.message)) || 'Sorry, this item could not be added.';
    if (typeof text !== 'string') text = String(text);
    var p = document.createElement('p');
    p.className = 'warning animated bounceIn';
    p.textContent = text.replace('All 1 ', 'All ');
    form.parentNode.insertBefore(p, form.nextSibling);
  }

  function add(btn, form) {
    if (btn.classList.contains('is-citimi-loading')) return;
    $$('.warning').forEach(function (w) { w.remove(); });
    var recipient = form.querySelector('[data-recipient-form]');
    if (recipient) recipient.classList.remove('recipient-form--has-errors');
    setLoading(btn, true);
    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);
    queue = queue.then(function () {
      return post('cart/add.js', fd, true)
        .then(function (data) {
          return render(data.sections).then(function () {
            if (window.jQuery && window.jQuery.fancybox && document.body.classList.contains('fancybox-active')) window.jQuery.fancybox.close();
            open();
          }, function () {
            // added, but the drawer could not be refreshed: show the cart page instead
            window.location.href = ROOT + 'cart';
          });
        }, function (err) {
          // Shopify's own message (e.g. not enough stock), or a connection problem
          showError(form, btn, err && err.data ? err.data : { description: 'Sorry, something went wrong. Please try again.' });
        })
        .then(function () { setLoading(btn, false); });
    });
  }

  /* ---------- inside the drawer ---------- */
  function changeLine(item, qty) {
    var key = item.getAttribute('data-key');
    item.classList.add('is-busy');
    queue = queue.then(function () {
      return post('cart/change.js', { id: key, quantity: Math.max(0, qty), sections: SECTION, sections_url: window.location.pathname })
        .then(function (data) { return render(data.sections); })
        .catch(function (err) {
          item.classList.remove('is-busy');
          var msg = item.querySelector('.citimi-cart__error');
          if (!msg) {
            msg = document.createElement('p');
            msg.className = 'citimi-cart__error';
            var info = item.querySelector('.citimi-cart__info') || item;
            info.appendChild(msg);
          }
          msg.textContent = (err && err.data && (err.data.description || err.data.message)) || 'Sorry, something went wrong.';
        });
    });
  }

  function clearCart() {
    var content = $('[data-citimi-cart-content]', drawer);
    if (content) content.classList.add('is-busy');
    queue = queue.then(function () {
      return post('cart/clear.js', { sections: SECTION, sections_url: window.location.pathname })
        .then(function (data) { return render(data.sections); })
        .catch(function () {})
        .then(function () { var c = $('[data-citimi-cart-content]', drawer); if (c) c.classList.remove('is-busy'); });
    });
  }

  function saveNote() {
    var note = drawer && $('[data-citimi-cart-note]', drawer);
    clearTimeout(noteTimer);
    if (!note || note.value === note.defaultValue) return; // unchanged since Shopify last rendered it
    note.defaultValue = note.value;
    post('cart/update.js', { note: note.value }).catch(function () {});
  }

  /* ---------- one click handler, in the capture phase so it runs before the theme's ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('.ajax-submit');
    var form = btn && btn.closest('form');
    if (btn && form && /\/cart\/add/.test(form.getAttribute('action') || '')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      add(btn, form);
      return;
    }

    if (t.closest('a.mini_cart')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isOpen()) close(); else open();
      return;
    }

    if (!drawer.contains(t)) {
      // phones: the menu or search in the header close the cart first
      if (isOpen() && t.closest('#header')) close();
      return;
    }

    if (t.closest('[data-citimi-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }
    var item = t.closest('.citimi-cart__item');
    var step = t.closest('[data-citimi-qty]');
    if (item && step) {
      var qty = (parseInt(item.getAttribute('data-qty'), 10) || 0) + parseInt(step.getAttribute('data-citimi-qty'), 10);
      changeLine(item, qty);
      return;
    }
    if (item && t.closest('[data-citimi-remove]')) {
      changeLine(item, 0);
      return;
    }
    if (t.closest('[data-citimi-cart-clear]')) {
      clearCart();
    }
  }

  function init() {
    drawer = $('[data-citimi-cart]');
    if (!drawer || onCartPage()) return;
    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });
    // the gift note is saved shortly after typing stops, and when the drawer closes
    drawer.addEventListener('input', function (e) {
      if (!e.target.matches('[data-citimi-cart-note]')) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveNote, 700);
    });
    drawer.addEventListener('submit', function () { clearTimeout(noteTimer); });
    window.addEventListener('resize', function () { if (isOpen()) place(); });
    document.documentElement.classList.add('has-citimi-cart');
    // the theme's small drop-down cart: no more opening on hover. The theme binds it on DOMContentLoaded,
    // which comes after this deferred file runs, so unbind after that.
    if (document.readyState === 'complete') unbindThemeMiniCart();
    else document.addEventListener('DOMContentLoaded', unbindThemeMiniCart);
    window.addEventListener('load', unbindThemeMiniCart);
  }

  function unbindThemeMiniCart() {
    if (!window.jQuery) return;
    window.jQuery('.cart-container').off('mouseenter mouseleave');
    window.jQuery('.mini_cart').off('click');
    window.jQuery('.cart-container').removeClass('active_link');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
